// =============================================================================
// gst.ts — pure Australian GST arithmetic for the Resources GST calculator
// =============================================================================
// No I/O, no React — just the two directions of the 10% GST calc, so it can be
// unit-tested and the component stays a thin renderer. Used by
// components/resources/GstCalculator.jsx (embedded on Resources pages via the
// [[gst-calculator]] shortcode).
//
// AU GST = 10%. On a GST-EXCLUSIVE price the GST is amount × 0.10. Inside a
// GST-INCLUSIVE price the GST component is amount ÷ 11 (i.e. 1/11 of the total),
// leaving a base of amount × 10/11.
// =============================================================================

export const GST_RATE = 0.1;

export interface GstBreakdown {
  base: number; // ex-GST amount
  gst: number; // the GST component
  total: number; // GST-inclusive amount
}

// Treat the entered amount as GST-EXCLUSIVE and add 10%.
export function addGst(exclusive: number): GstBreakdown {
  const base = Number.isFinite(exclusive) ? exclusive : 0;
  const gst = base * GST_RATE;
  return { base, gst, total: base + gst };
}

// Treat the entered amount as GST-INCLUSIVE and back the GST out (÷ 11).
export function extractGst(inclusive: number): GstBreakdown {
  const total = Number.isFinite(inclusive) ? inclusive : 0;
  const gst = total / 11;
  return { base: total - gst, gst, total };
}
